import { render, staticRenderFns } from "./AddressManagement.vue?vue&type=template&id=37056933&scoped=true"
import script from "./AddressManagement.vue?vue&type=script&lang=js"
export * from "./AddressManagement.vue?vue&type=script&lang=js"
import style0 from "./AddressManagement.vue?vue&type=style&index=0&id=37056933&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37056933",
  null
  
)

export default component.exports